// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__9orDd","ContactHeader":"Footer_ContactHeader__iVWvd"};